import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root',
})

export class PostHogService {

    async identify(company_id:any, rut:string, business_name:string){

        posthog.identify(
            company_id, 
            {
                rut: rut, 
                business_name: business_name
            }
        );
        
    }

    async capture(vista:string, code:any, endpoint:any, description:string, platform:string, paso_onboarding?:any){

        posthog.capture(
            vista, 
            {
                code: code,
                endpoint: endpoint,
                description: description,
                platform: platform,
                paso_onboarding: paso_onboarding

            }
        );
    }

 

}